import { render, staticRenderFns } from "./VideoPopup.vue?vue&type=template&id=6054cd86&"
import script from "./VideoPopup.vue?vue&type=script&lang=js&"
export * from "./VideoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VideoPopup.vue"
export default component.exports